import { Module } from 'vuex'
import PublishLocalExamService from '@/services/Localization/PublishLocalExam'
import i18n from '@/i18n'              // <-- import your i18n instance
import { useToast } from 'vue-toastification'
import { handle418Error } from '@/utils/errorHandlers'

const toast = useToast()

export interface LocalExamState {
  loading: boolean
}

const localExamModule: Module<LocalExamState, any> = {
  namespaced: true,

  state: () => ({
    loading: false
  }),

  mutations: {
    SET_LOADING(state, value: boolean) {
      state.loading = value
    }
  },

  actions: {
   async publishLocalExam({ commit, dispatch }, examIds: number | number[]) {
  commit('SET_LOADING', true)
  try {
    const response = await PublishLocalExamService.publish(examIds)
    toast.success(i18n.global.t("messages.exams.publish_many.success"))
  
    return response
  } catch (error: any) {
     
    if (error.status === 418) {
           const title = `${i18n.global.t('exams.publish')} “${examIds}”`
  if (!handle418Error(dispatch, error, title)) {
    toast.error(error)
  }
    }
  } finally {
    commit('SET_LOADING', false)
  }
},
    async unpublishLocalExam({ commit, dispatch  }, examIds: number | number[]) {
      commit('SET_LOADING', true)
      try {
        const response = await PublishLocalExamService.unpublish(examIds)
       toast.success(i18n.global.t("messages.exams.unpublish.success"));
        return response
      }  catch (error: any) {

    if (error.status === 418) {
           const title = `${i18n.global.t('exams.unpublish')} “${examIds}”`
  if (!handle418Error(dispatch, error, title )) {
    toast.error(error)
  }
    }
  } finally {
    commit('SET_LOADING', false)
  }
    },

    async deleteLocalExam({ commit }, examLocalizationIds: number[]) {
      commit('SET_LOADING', true)
      try {
        const response = await PublishLocalExamService.deletelocalexam(examLocalizationIds)
        toast.success(i18n.global.t("messages.exams.delete.success"));
        return response
      } catch (error: any) {
        toast.error(error)
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    }
  }
}

export default localExamModule
